import { bl_pos_terminal_session_hdr_RowClass } from '../../../dbschema/bl_pos_terminal_session_hdr.model';
import {BaseContainerModel} from '../../base-container.model';


export class PosTerminalSessionHdrContainerModel extends BaseContainerModel {
  bl_pos_terminal_session_hdr: bl_pos_terminal_session_hdr_RowClass = new bl_pos_terminal_session_hdr_RowClass();
}
